import { KatLitFilteredElement, register } from '../../shared/base';
import { KatHero } from '.';

/**
 * @component {kat-hero-actions} KatHeroActions Component used display hero actions.
 */
@register(KatHero.slotMapping.actions.name)
export class KatHeroActions extends KatLitFilteredElement {
  constructor() {
    super(
      KatHero.slotMapping.actions.name,
      KatHero.slotMapping.actions.allowed
    );
  }
}
